import cx from 'classnames';

const Typography = ({
  children,
  color = 'primary',
  weight = 'regular',
  lineHeight = 'none',
  className = '',
}) => {
  return (
    <div
      className={cx('', {
        // colors
        'text-[#0F172A]': color === 'primary',
        'text-[#5C6B7F]': color === 'secondary',
        'text-white': color === 'white',
        'text-[#DBEAFEE5]': color === 'lightblue',
        'text-cauzeorange': color === 'orange',
        'text-[#3E6A3E]': color === 'green',
        // font weights
        'font-agenda-bold': weight === 'bold',
        'font-agenda-semibold': weight === 'semibold',
        'font-agenda': weight === 'regular',
        'font-agenda-medium': weight === 'medium',
        'font-agenda-black': weight === 'black',
        // line heights
        'leading-none': lineHeight === 'none',
        'leading-tight': lineHeight === 'tight',
        'leading-snug': lineHeight === 'snug',
        'leading-normal': lineHeight === 'normal',
        'leading-relaxed': lineHeight === 'relaxed',
        'leading-loose': lineHeight === 'loose',
        // other
        [className]: className,
      })}
    >
      {children}
    </div>
  );
};

export default Typography;
